import { render } from "./Q2Detaillee.vue?vue&type=template&id=71d7404e"
import script from "./Q2Detaillee.vue?vue&type=script&lang=js"
export * from "./Q2Detaillee.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__